<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div  class="card-group">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Instructions说明：</h4>
                        <p class="card-text">a. Checklist is to be used prior to performing a lift defined as critical.<br/>在进行高风险吊装作业之前使用本检查表。</p>
                        <p class="card-text">b. The lifting team is to use checklist in a "Challenge and Response" format wherein the crane operator poses the question and the spotter responds with answer.<br/>   吊装团队采用“问和答”的检查表模式，起重工提出问题，司索指挥工回答问题。</p>
                        <p class="card-text">c. Utilize page two(Lift Diagram)to detail lift steps,rigging and sketch of lift.<br/>利用第二页的吊装图详述起吊、司索、吊运的整个步骤过程。</p>
                        <p class="card-text">d. Determine communication plan.<br/>确定沟通方案。</p>
                        <p class="card-text">e. Maintain copies for auditing and development of detailed lifting procedures.<br/>保存用于审核的文本资料,制定详细的吊装程序。</p>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header text-center">
                        CRITICAL LIFT DEFINITION 高风险吊装定义
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">Any lift exceeding 75% of total capacity of the crane 超过起重机总起重能力的75%;</li>
                        <li class="list-group-item">Requires use of more than one crane 要求使用一台以上的起重机;</li>
                        <li class="list-group-item">Flipping when the object has an undetermined center of gravity 吊物重心未确定导致翻转;</li>
                        <li class="list-group-item">The lifting team and/or local management identifies any other lift that would pose an increased risk of<br/>injury or property damage.(i.e awkward, center of gravity,non-standard lifting attachments,proficiency)<br/>吊装团队和/或现场管理员识别出其他任何可能造成伤害或财产损失风险增加的吊装（亦即难吊运的、重心偏移、非标准的吊装附件、低熟练度等）。</li>
                        <li class="list-group-item text-white bg-danger">当不确认是否填写高风险吊装或是否需要EHS见证时,可联系主管使用该表进行判断。<br/>判断小工具: S:\00_General\A04 Business Excellence\013_BE2-HSE Management环境健康安全管理\000 General 通用\012吊装检查表使用小工具</li>
                    </ul>
                </div>
            </div>
            <div class="card mt-1">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"
                                         :$_em-custom-vuex-mixin_entity="entityState">
                    </em-entity-edit-form>
                </div>
            </div>
            
        </section>
    </div>
</template>

<script>
    // Author Lin
    // Date 2022-07-20 09:50:21

    import emCommonEditMixin from "@/mixin/em/common/edit";

    export default {
        name: "sithMesInventoryLiftCheckEditView",
        mixins: [emCommonEditMixin],
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
            entityState() {
                return this.$route.query.hasOwnProperty('entityState') ? this.$route.query.entityState : 'entity';
            }
        }
    };
</script>